const deliveryConfirmationPT = {
    "view": {
        "table": {
            "title": "Lista de Entregas",
            "columns": {
                "release": "Lançamento",
                "upc": "Número UPC",
                "action": "Ação",
                "status": "Status",
                "deliveryDate": "Data de Entrega",
                "details": "Detalhes"
            },
            "label": {
                "statusDelivered": "ENTREGUE",
                "statusPartially": "PARCIALMENTE",
                "statusUndelivered": "NÃO ENTREGUE",
                "ddexActionInsert": "INSERIR",
                "ddexActionFullUpdate": "ATUALIZAÇÃO COMPLETA",
                "ddexActionMetadataUpdate": "ATUALIZAÇÃO DE META.",
                "ddexActionTakedown": "RETIRADA"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "button": {
                "open": "ABRIR",
                "exportCSV": "Exportar CSV"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Lista de Entrega de Lojas",
            "column": {
                "store": "Loja",
                "additionalNote": "Notas Adicionais",
                "status": "Status"
            },
            "label": {
                "statusDelivered": "ENTREGUE",
                "statusUndelivered": "NÃO ENTREGUE"
            },
            "button": {
                "exportCSV": "Exportar CSV"
            },
            "message": {
                "appleSubjectToQC": "Entregue com sucesso, sujeito a controle de QC adicional pela equipe da Apple Music.",
                "releaseDeliverySuccessfull": "Lançamento foi entregue com sucesso aos servidores do {{dspName}}",
                "releaseDeliveryUnsuccessfull": "Entrega do lançamento foi malsucedida para {dspName}.",
                "noDeliveriesPossible": "Nenhuma entrega possível no momento"
            }
        }
    }
};

export default deliveryConfirmationPT;